import {
  Box,
  Container,
  Flex,
  HStack,
  Link,
  Button,
  IconButton,
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  VStack,
  Image,
  useDisclosure,
  useColorMode,
  useColorModeValue,
} from '@chakra-ui/react';
import { HamburgerIcon, SunIcon, MoonIcon } from '@chakra-ui/icons';
import { FiDownload } from 'react-icons/fi';
import TmrBar from './TmrBar';
import logoImpicomWhite from '../../assets/images/Logo_impicom.webp';
import logoImpicomColor from '../../assets/images/Logo_impicom_color.webp';

const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Nosotros', href: '#nosotros' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Proyectos', href: '#proyectos' },
  { label: 'Proceso', href: '#proceso' },
  { label: 'Contacto', href: '#contacto' },
];

function Header() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();
  const headerBg = useColorModeValue('rgba(255, 255, 255, 0.95)', 'dark.900');
  const borderColor = useColorModeValue('tint.200', 'dark.700');
  const drawerBg = useColorModeValue('white', 'dark.800');
  const logoSrc = useColorModeValue(logoImpicomColor, logoImpicomWhite);
  const hoverColor = useColorModeValue('brand.600', 'brand.300');

  return (
    <Box
      as="header"
      position="sticky"
      top={0}
      zIndex={10}
      backdropFilter="blur(10px)"
      bg={headerBg}
      borderBottom="1px solid"
      borderColor={borderColor}
    >
      <Container maxW="1120px">
        <Flex align="center" justify="space-between" gap={6} py={5}>
          {/* Brand */}
          <Link href="#inicio" _hover={{ textDecoration: 'none' }}>
            <HStack spacing={3}>
              <Image
                src={logoSrc}
                alt="Impicom Logo"
                h="50px"
                w="auto"
                objectFit="contain"
              />
            </HStack>
          </Link>

          {/* Desktop Nav */}
          <HStack
            as="nav"
            spacing={4}
            display={{ base: 'none', md: 'flex' }}
            aria-label="Navegacion principal"
          >
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                fontSize="sm"
                opacity={0.8}
                _hover={{ opacity: 1, textDecoration: 'none' }}
              >
                {link.label}
              </Link>
            ))}
          </HStack>

          {/* Desktop Actions */}
          <HStack spacing={2} display={{ base: 'none', md: 'flex' }}>
            <IconButton
              aria-label={colorMode === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
              icon={colorMode === 'dark' ? <SunIcon /> : <MoonIcon />}
              onClick={toggleColorMode}
              variant="ghost"
              size="sm"
            />
            <Button
              as="a"
              href="/brochure-impicom.pdf"
              download
              variant="ghost"
              size="sm"
              leftIcon={<FiDownload />}
            >
              Brochure
            </Button>
            <Button
              as="a"
              href="#contacto"
              variant="primary"
              size="sm"
            >
              Cotizar
            </Button>
          </HStack>

          {/* Mobile Actions */}
          <HStack spacing={2} display={{ base: 'flex', md: 'none' }}>
            <IconButton
              aria-label={colorMode === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
              icon={colorMode === 'dark' ? <SunIcon /> : <MoonIcon />}
              onClick={toggleColorMode}
              variant="ghost"
              size="sm"
            />
            <IconButton
              aria-label="Abrir menu"
              icon={<HamburgerIcon />}
              variant="ghost"
              onClick={onOpen}
            />
          </HStack>
        </Flex>
      </Container>

      {/* Mobile Drawer */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg={drawerBg}>
          <DrawerCloseButton />
          <DrawerBody>
            <VStack spacing={4} align="stretch">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  fontSize="lg"
                  onClick={onClose}
                  _hover={{ textDecoration: 'none', color: hoverColor }}
                >
                  {link.label}
                </Link>
              ))}
              <Button
                as="a"
                href="/brochure-impicom.pdf"
                download
                onClick={onClose}
                variant="outline"
                leftIcon={<FiDownload />}
                mt={4}
              >
                Descargar brochure
              </Button>
              <Button
                as="a"
                href="#contacto"
                onClick={onClose}
                variant="primary"
              >
                Cotizar
              </Button>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <TmrBar />
    </Box>
  );
}

export default Header;
